/* Support page behaviour. Markup: sections/sp-page.liquid. */
(function () {
  var form = document.getElementById('sp-form');
  if (!form) return;

  // Optional chip groups: tapping the selected chip again clears it.
  form.addEventListener('click', function (e) {
    var input = e.target.closest('.sp-chip') && e.target.closest('.sp-chip').querySelector('input[type=radio]');
    if (!input) return;
    if (input.dataset.was === 'on') {
      e.preventDefault();
      input.checked = false;
      input.dataset.was = '';
      return;
    }
    form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (r) { r.dataset.was = ''; });
    setTimeout(function () { if (input.checked) input.dataset.was = 'on'; }, 0);
  });

  // ---- Photos and videos (optional). Files go straight from the browser to Shopify's storage;
  // the upload service only signs the slots and returns one link per file for the email.
  var box = form.querySelector('[data-sp-files]');
  var up = box ? {
    url: (box.getAttribute('data-upload-url') || '').replace(/\/+$/, ''),
    input: box.querySelector('[data-sp-file-input]'),
    list: box.querySelector('[data-sp-file-list]'),
    attach: box.querySelector('[data-sp-attach]'),
    items: [], ref: null, labels: [],
    MAX: 5, IMG: 20 * 1048576, VID: 300 * 1048576, SECS: 135
  } : null;
  var fallback = form.querySelector('[data-sp-files-fallback]');

  function fmtMB(n) { return n >= 1048576 ? (n / 1048576).toFixed(n >= 10485760 ? 0 : 1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }
  function kindOf(f) {
    var t = (f.type || '').toLowerCase(), ext = (f.name.split('.').pop() || '').toLowerCase();
    if (/^image\/(jpeg|png|webp|heic|heif|gif)$/.test(t) || /^(jpe?g|png|webp|heic|heif|gif)$/.test(ext)) return 'photo';
    if (/^video\/(mp4|quicktime|x-m4v)$/.test(t) || /^(mp4|mov|m4v)$/.test(ext)) return 'video';
    return '';
  }
  function videoSeconds(f) {
    return new Promise(function (res) {
      try {
        var v = document.createElement('video'), u = URL.createObjectURL(f), t = setTimeout(function () { res(0); }, 4000);
        v.preload = 'metadata';
        v.onloadedmetadata = function () { clearTimeout(t); URL.revokeObjectURL(u); res(v.duration || 0); };
        v.onerror = function () { clearTimeout(t); URL.revokeObjectURL(u); res(0); };
        v.src = u;
      } catch (e) { res(0); }
    });
  }
  // Shopify stores photos up to 25 megapixels and 20 MB. Big phone photos (48 MP and up) are scaled
  // down in the browser first, so they upload faster and are never refused. If the browser can't
  // read the photo (e.g. HEIC outside Safari) it is sent as is.
  var MAX_PX = 24000000;
  function fitPhoto(f) {
    if (!window.createImageBitmap || !document.createElement('canvas').toBlob) return Promise.resolve(f);
    return createImageBitmap(f).then(function (bmp) {
      var px = bmp.width * bmp.height;
      if (px <= MAX_PX && f.size <= up.IMG) { bmp.close && bmp.close(); return f; }
      var k = Math.min(1, Math.sqrt(MAX_PX / px)) * (f.size > up.IMG && px <= MAX_PX ? 0.85 : 1);
      var c = document.createElement('canvas');
      c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      bmp.close && bmp.close();
      return new Promise(function (res) {
        c.toBlob(function (b) {
          if (!b) return res(f);
          var name = f.name.replace(/\.[^.]+$/, '') + '.jpg';
          try { res(new File([b], name, { type: 'image/jpeg' })); } catch (e) { b.name = name; res(b); }
        }, 'image/jpeg', 0.9);
      });
    }).catch(function () { return f; });
  }
  // What the customer has typed so far; used to name the files in Shopify (name, order, topic).
  function about() {
    function v(n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; }
    return { name: v('name'), email: v('email'), order: v('Order number'), topic: v('Topic') };
  }
  function pending() { return up ? up.items.filter(function (it) { return it.state === 'up'; }) : []; }
  function renderAttach() {
    var counts = { photo: 0, video: 0 }, html = '';
    up.items.forEach(function (it) {
      if (it.state !== 'done' || !it.link) return;
      counts[it.kind]++;
      var label = (it.kind === 'video' ? 'Video ' : 'Photo ') + counts[it.kind];
      html += '<input type="hidden" name="contact[' + label + ']" value="' + it.link.replace(/"/g, '&quot;') + '">';
    });
    if (html && up.ref) html = '<input type="hidden" name="contact[Upload reference]" value="' + up.ref + '">' + html;
    up.attach.innerHTML = html;
  }
  function drawItem(it) {
    if (!it.el) {
      it.el = document.createElement('li');
      it.el.className = 'sp-file';
      it.el.innerHTML = '<span class="sp-file__k" aria-hidden="true"></span><span class="sp-file__n"></span><span class="sp-file__s" aria-live="polite"></span><button type="button" class="sp-file__x" aria-label="Remove">×</button><span class="sp-file__bar"><i></i></span>';
      it.el.querySelector('.sp-file__x').addEventListener('click', function () {
        if (it.xhr) try { it.xhr.abort(); } catch (e) {}
        it.state = 'gone';
        it.el.remove();
        up.items = up.items.filter(function (x) { return x !== it; });
        renderAttach(); syncButton();
      });
      up.list.appendChild(it.el);
    }
    it.el.setAttribute('data-state', it.state);
    it.el.querySelector('.sp-file__k').textContent = it.kind === 'video' ? '▶' : '◻';
    it.el.querySelector('.sp-file__n').textContent = it.file.name;
    var s = it.state === 'up' ? (it.pct || 0) + '%' : it.state === 'done' ? 'Added' : it.msg || 'Couldn\'t add';
    it.el.querySelector('.sp-file__s').textContent = s;
    it.el.querySelector('.sp-file__bar i').style.width = (it.state === 'done' ? 100 : it.pct || 0) + '%';
  }
  function fail(it, msg) { it.state = 'err'; it.msg = msg; drawItem(it); syncButton(); }
  function post(path, body) {
    return fetch(up.url + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); });
  }
  function sendToStorage(it, target) {
    return new Promise(function (res) {
      var fd = new FormData();
      target.parameters.forEach(function (p) { fd.append(p.name, p.value); });
      fd.append('file', it.file);
      var x = new XMLHttpRequest();
      it.xhr = x;
      x.open('POST', target.url);
      x.upload.onprogress = function (e) { if (e.lengthComputable) { it.pct = Math.min(99, Math.round(e.loaded / e.total * 100)); drawItem(it); syncButton(); } };
      x.onload = function () { res(x.status >= 200 && x.status < 300); };
      x.onerror = x.onabort = function () { res(false); };
      x.send(fd);
    });
  }
  function uploadBatch(batch) {
    // Photos and videos are numbered across batches (photo-1, photo-2...), so tell the service where to continue.
    var counts = { photo: 0, video: 0 };
    up.items.forEach(function (it) { if (it.n) counts[it.kind] = Math.max(counts[it.kind], it.n); });
    var next = { photo: counts.photo, video: counts.video };
    batch.forEach(function (it) { it.n = ++next[it.kind]; });
    post('/uploads/start', { ref: up.ref, about: about(), counts: counts,
      files: batch.map(function (it) { return { name: it.file.name, type: it.file.type, size: it.file.size }; }) })
      .then(function (r) {
        if (!r.ok) { batch.forEach(function (it) { fail(it, r.error || 'Couldn\'t add this file'); }); return; }
        up.ref = r.ref || up.ref;
        return Promise.all(batch.map(function (it, i) { return sendToStorage(it, r.targets[i]); })).then(function (oks) {
          var done = [];
          oks.forEach(function (ok, i) { if (ok && batch[i].state === 'up') done.push(i); else if (batch[i].state === 'up') fail(batch[i], 'Upload failed. Try again.'); });
          if (!done.length) return;
          return post('/uploads/finish', { ticket: r.ticket, done: done, about: about() }).then(function (f) {
            if (f && f.label) up.labels.push(f.label);
            done.forEach(function (i, n) {
              var it = batch[i];
              if (it.state !== 'up') return;
              if (f.ok && f.links && f.links[n]) { it.state = 'done'; it.link = f.links[n]; drawItem(it); }
              else fail(it, (f && f.error) || 'Couldn\'t save this file');
            });
          });
        });
      })
      .catch(function () { batch.forEach(function (it) { if (it.state === 'up') fail(it, 'Upload failed. Try again.'); }); })
      .then(function () { renderAttach(); syncButton(); });
  }
  function addFiles(files) {
    var room = up.MAX - up.items.filter(function (it) { return it.state !== 'err'; }).length;
    var picked = Array.prototype.slice.call(files);
    var checks = picked.map(function (f, n) {
      var it = { file: f, kind: kindOf(f), state: 'up', pct: 0 };
      if (n >= room) { it.state = 'err'; it.msg = 'Up to 5 files'; return Promise.resolve(it); }
      if (!it.kind) { it.state = 'err'; it.msg = 'Photos or videos only'; return Promise.resolve(it); }
      if (it.kind === 'photo') return fitPhoto(f).then(function (g) {
        it.file = g;
        if (g.size > up.IMG) { it.state = 'err'; it.msg = 'Over 20 MB'; }
        return it;
      });
      if (it.kind === 'video' && f.size > up.VID) { it.state = 'err'; it.msg = 'Too long (2 min max)'; return Promise.resolve(it); }
      if (it.kind !== 'video') return Promise.resolve(it);
      return videoSeconds(f).then(function (sec) { if (sec > up.SECS) { it.state = 'err'; it.msg = 'Too long (2 min max)'; } return it; });
    });
    Promise.all(checks).then(function (its) {
      its.forEach(function (it) { up.items.push(it); drawItem(it); });
      var batch = its.filter(function (it) { return it.state === 'up'; });
      if (batch.length) uploadBatch(batch);
      syncButton();
    });
  }
  var btn = form.querySelector('[data-sp-submit]');
  var btnText = btn ? btn.textContent : '';
  // While photos or videos are still uploading the send button waits, so the message can't go
  // out without them (Shopify's captcha may submit the form by itself once a send starts).
  function syncButton() {
    if (!btn || btn.dataset.sent) return;
    var p = pending();
    if (!p.length) { btn.disabled = false; btn.textContent = btnText; return; }
    var pct = Math.round(p.reduce(function (a, it) { return a + (it.pct || 0); }, 0) / p.length);
    btn.disabled = true;
    btn.textContent = 'Uploading ' + (p.length > 1 ? p.length + ' files' : 'file') + '… ' + pct + '%';
  }

  if (up && up.url && up.input) {
    // Show the picker only when the service answers; otherwise keep the "reply to our email" note.
    var ctl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    fetch(up.url + '/health', ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        clearTimeout(to);
        if (!j || !j.ok || j.uploads === false) return;
        box.hidden = false;
        if (fallback) fallback.hidden = true;
      }).catch(function () {});
    up.input.addEventListener('change', function () {
      if (up.input.files && up.input.files.length) addFiles(up.input.files);
      up.input.value = '';
    });
  }

  // One send only: lock the button the moment the form submits.
  form.addEventListener('submit', function (e) {
    if (pending().length) { e.preventDefault(); syncButton(); return; }
    // Final details for the file names (in case files were added before the form was filled in).
    if (up && up.labels.length && navigator.sendBeacon) {
      try { navigator.sendBeacon(up.url + '/uploads/label', new Blob([JSON.stringify({ labels: up.labels, about: about() })], { type: 'text/plain' })); } catch (err) {}
    }
    // Leave empty optional fields out of the email so the team only sees what was filled in.
    form.querySelectorAll('[data-sp-optional]').forEach(function (f) { if (!f.value.trim()) f.disabled = true; });
    var b = form.querySelector('[data-sp-submit]');
    if (!b) return;
    if (b.dataset.sent) return;
    b.dataset.sent = '1';
    setTimeout(function () { b.disabled = true; b.textContent = 'Sending…'; }, 0);
  });

  // After a successful send, drop the ?contact_posted query from the address so a refresh or back
  // shows the confirmation page cleanly, and bring the confirmation into view.
  if (/[?&]contact_posted=true/.test(location.search)) {
    // Shopify returns to #sp-form, which tucks the confirmation under the sticky header.
    // The confirmation is the first thing on the page, so show the page from the top.
    var top = function () { window.scrollTo(0, 0); };
    // Tracking: one "Contact" conversion per sent message (Meta, TikTok, GA4/GTM via dataLayer).
    try {
      // Only on the arrival right after sending, not on a refresh or back/forward visit.
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type === 'navigate') {
        (window.dataLayer = window.dataLayer || []).push({ event: 'contact_form_submit', form: 'contact-us' });
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('contact_form_submit', { form: 'contact-us' }); } catch (e) {}
        // Ad pixels load after this script, so wait (up to 10s) for each and send once.
        var sent = {}, tries = 0;
        var fire = function () {
          if (!sent.fb && window.fbq) { sent.fb = 1; window.fbq('track', 'Contact'); }
          if (!sent.tt && window.ttq && window.ttq.track) { sent.tt = 1; window.ttq.track('Contact'); }
          if (!sent.ga && window.gtag) { sent.ga = 1; window.gtag('event', 'contact_form_submit', { form: 'contact-us' }); }
          if ((!sent.fb || !sent.tt || !sent.ga) && ++tries < 20) setTimeout(fire, 500);
        };
        fire();
      }
    } catch (e) {}
    top(); window.addEventListener('load', function () { setTimeout(top, 50); });
  }
})();
